import React, { useState, useEffect } from 'react';
import '../styles/styles.css';

const ElectricalReference = () => {
  // 상태 관리
  const [activeTab, setActiveTab] = useState('wire');
  const [activeWireSubTab, setActiveWireSubTab] = useState('types');
  const [searchText, setSearchText] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [calculatorInputs, setCalculatorInputs] = useState({
    load: '',
    distance: '',
    voltageType: '220',
    wireType: 'CV'
  });
  const [calculatorResults, setCalculatorResults] = useState(null);

  // 전선 종류 데이터
  const wireTypesData = [
    { id: 'cv', title: 'CV 전선', description: '가교 폴리에틸렌 절연 비닐 시스 케이블', image: '/images/wire/wire-cv.jpg' },
    { id: 'hiv', title: 'HIV 전선', description: '내열 비닐 절연전선', image: '/images/wire/wire-hiv.jpg' },
    { id: 'vv', title: 'VV 전선', description: '비닐 절연 비닐 시스 케이블', image: '/images/wire/wire-vv.jpg' },
    { id: 'awg', title: 'AWG 규격', description: '미국 전선 규격 (American Wire Gauge)', image: '/images/wire/wire-awg.jpg' },
    { id: 'hfix', title: 'HFIX 전선', description: '내열 난연 비닐 절연전선', image: '/images/wire/wire-hfix.jpg' },
    { id: 'xlpe', title: 'XLPE 케이블', description: '가교 폴리에틸렌 절연 케이블', image: '/images/wire/wire-xlpe.jpg' },
    { id: 'fr', title: 'FR 케이블', description: '난연 케이블 (Flame Retardant)', image: '/images/wire/wire-fr.jpg' },
    { id: 'tfr-cv', title: 'TFR-CV 케이블', description: '내화 케이블 (화재 시에도 일정 시간 기능 유지)', image: '/images/wire/wire-tfr.jpg' },
    { id: 'acb', title: 'ACB 케이블', description: '알루미늄 도체 케이블 (Aluminum Conductor)', image: '/images/wire/wire-acb.jpg' }
  ];

  // 전선 굵기별 허용전류 데이터 (220V 및 380V 기준)
  const wireSizeCurrentData = [
    { 
      size: '1.5mm²', 
      allowableCurrent220V: '16A', 
      allowableCurrent380V: '13A', 
      application: '조명 회로' 
    },
    { 
      size: '2.5mm²', 
      allowableCurrent220V: '22A', 
      allowableCurrent380V: '19A', 
      application: '소형 전열기구' 
    },
    { 
      size: '4mm²', 
      allowableCurrent220V: '30A', 
      allowableCurrent380V: '26A', 
      application: '중형 전열기구' 
    },
    { 
      size: '6mm²', 
      allowableCurrent220V: '38A', 
      allowableCurrent380V: '34A', 
      application: '대형 전열기구' 
    },
    { 
      size: '10mm²', 
      allowableCurrent220V: '52A', 
      allowableCurrent380V: '46A', 
      application: '중소형 동력' 
    },
    { 
      size: '16mm²', 
      allowableCurrent220V: '70A', 
      allowableCurrent380V: '62A', 
      application: '중형 동력' 
    },
    { 
      size: '25mm²', 
      allowableCurrent220V: '94A', 
      allowableCurrent380V: '83A', 
      application: '대형 동력' 
    },
    { 
      size: '35mm²', 
      allowableCurrent220V: '114A', 
      allowableCurrent380V: '103A', 
      application: '대형 동력' 
    },
    { 
      size: '50mm²', 
      allowableCurrent220V: '138A', 
      allowableCurrent380V: '125A', 
      application: '변압기 인입' 
    },
    { 
      size: '70mm²', 
      allowableCurrent220V: '176A', 
      allowableCurrent380V: '158A', 
      application: '변압기 인입' 
    },
    { 
      size: '95mm²', 
      allowableCurrent220V: '212A', 
      allowableCurrent380V: '190A', 
      application: '변압기 인입' 
    },
    { 
      size: '120mm²', 
      allowableCurrent220V: '245A', 
      allowableCurrent380V: '220A', 
      application: '수변전 설비' 
    },
  ];

  // 용도별 권장 전선 종류 데이터
  const wireApplicationData = [
    { 
      application: '일반 배선', 
      recommendedWire: 'HIV 2.5mm²', 
      description: '일반 콘센트 및 소형 전열기구',
      details: '가정 및 사무실의 일반 콘센트 회로에 사용되며, 다수의 소형 가전제품을 연결할 수 있습니다. 일반적으로 한 개의 회로당 최대 10개 이하의 콘센트를 연결하는 것이 권장됩니다.'
    },
    { 
      application: '에어컨 배선', 
      recommendedWire: 'HIV 4mm²', 
      description: '벽걸이 에어컨 전용',
      details: '가정용 벽걸이 에어컨(1~2kW)용 전용 배선으로, 냉방기 특성상 기동 시 높은 전류가 필요하기 때문에 일반 배선보다 굵은 전선을 사용합니다. 대용량 시스템 에어컨의 경우 6mm² 이상이 필요할 수 있습니다.'
    },
    { 
      application: '주방 전용 배선', 
      recommendedWire: 'HIV 4mm²', 
      description: '주방 전용 콘센트',
      details: '전자레인지, 전기밥솥, 전기오븐 등 전력 소모가 큰 주방 가전기기 사용을 위한 전용 회로입니다. 열 발생이 많은 환경이므로 내열성이 좋은 전선을 사용하며, 별도의 과전류 차단기를 설치하는 것이 좋습니다.'
    },
    { 
      application: '전기레인지 배선', 
      recommendedWire: 'HIV 6mm²', 
      description: '전기레인지 전용',
      details: '가정용 전기레인지(3~5kW)를 위한 전용 배선으로, 높은 전력 소모를 감당할 수 있어야 합니다. 반드시 별도의 전용 회로로 구성해야 하며, 30A 이상의 전용 차단기를 설치해야 합니다.'
    },
    { 
      application: '욕실 전용 배선', 
      recommendedWire: 'HIV 2.5mm² (방수처리)', 
      description: '욕실 방수 처리된 배선',
      details: '욕실과 같은 습기가 많은 환경에는 반드시 방수 처리된 전기 설비를 사용해야 합니다. 누전 차단기 설치가 필수적이며, 콘센트는 방수 커버가 있는 제품을 사용해야 합니다. 전선 연결부는 방수 처리를 철저히 해야 합니다.'
    },
    { 
      application: '옥외 배선', 
      recommendedWire: 'CV 4mm²', 
      description: '옥외 환경에 적합한 내후성',
      details: '외부 환경에 노출되는 배선으로 자외선, 비, 눈 등에 견딜 수 있는 내후성을 갖추어야 합니다. CV 케이블은 습기와 직사광선에 강하며, 지중 매설 시에는 보호관을 통해 추가 보호가 필요합니다.'
    },
    { 
      application: '지중 매설 배선', 
      recommendedWire: 'CV 6mm² 이상', 
      description: '지중 매설용 케이블',
      details: '지중에 매설되는 전선은 물리적 손상과 습기에 대한 저항성이 높아야 합니다. 매설 깊이는 최소 60cm 이상이 권장되며, 보호관 및 모래층 포설, 경고 테이프 설치 등의 추가 보호 조치가 필요합니다.'
    },
    { 
      application: '소방 설비 배선', 
      recommendedWire: 'HFIX 1.5mm²', 
      description: '내화/내열성 전선',
      details: '화재 경보기, 스프링클러 등 소방 설비의 배선에는 화재 시에도 일정 시간 기능을 유지할 수 있는 내화 성능의 전선이 필요합니다. 소방법에 따라 내화배선 또는 내열배선 기준을 충족해야 하며, 비상 전원과 연결되어야 합니다.'
    },
  ];

  // 규격 및 법규 데이터
  const regulationsData = [
    { id: 'tech-standard', title: '전기설비기술기준', description: '전기설비의 안전성 확보를 위한 기술적 요건' },
    { id: 'wiring-reg', title: '내선규정', description: '옥내 전기설비의 시설에 관한 표준' },
  ];

  // 부하 용량에 따른 적정 전선 굵기 계산
  const calculateWireSize = () => {
    const { load, distance, voltageType, wireType } = calculatorInputs;
    
    if (!load || !distance) return;
    
    const loadValue = parseFloat(load);
    const distanceValue = parseFloat(distance);
    
    // 단순화된 계산 로직 (실제로는 더 복잡한 공식 사용 필요)
    let current = 0;
    if (voltageType === '220') {
      current = loadValue / 220;
    } else if (voltageType === '380') {
      current = loadValue / (380 * Math.sqrt(3));
    }
    
    // 안전계수 적용
    current = current * 1.25;
    
    // 거리에 따른 전압강하 고려
    const voltageDrop = (current * distanceValue * 0.018) / 1000; // 단순화된 계산
    
    // 전선 굵기 추천
    let recommendedSize = '';
    if (current <= 16) recommendedSize = '1.5mm²';
    else if (current <= 22) recommendedSize = '2.5mm²';
    else if (current <= 30) recommendedSize = '4mm²';
    else if (current <= 38) recommendedSize = '6mm²';
    else if (current <= 52) recommendedSize = '10mm²';
    else if (current <= 70) recommendedSize = '16mm²';
    else if (current <= 94) recommendedSize = '25mm²';
    else if (current <= 114) recommendedSize = '35mm²';
    else if (current <= 138) recommendedSize = '50mm²';
    else if (current <= 176) recommendedSize = '70mm²';
    else if (current <= 212) recommendedSize = '95mm²';
    else recommendedSize = '120mm² 이상';
    
    setCalculatorResults({
      current: current.toFixed(2),
      voltageDrop: voltageDrop.toFixed(2),
      recommendedSize,
      wireType
    });
  };

  // 카드 클릭 핸들러
  const handleCardClick = (contentType, data) => {
    setSelectedCard({ type: contentType, data });
    setModalContent(data);
    setModalIsOpen(true);
    document.body.style.overflow = 'hidden'; // 모달 열 때 스크롤 방지
  };

  // 모달 닫기 핸들러
  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent(null);
    document.body.style.overflow = 'auto'; // 모달 닫을 때 스크롤 복원
  };

  // 계산기 입력값 변경 핸들러
  const handleCalculatorInputChange = (e) => {
    const { name, value } = e.target;
    setCalculatorInputs({
      ...calculatorInputs,
      [name]: value
    });
  };

  // 필터링된 카드 데이터
  const getFilteredData = (dataArray) => {
    if (!searchText) return dataArray;
    
    return dataArray.filter(item => 
      Object.values(item).some(value => 
        typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  };

  // 탭 변경 핸들러
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCalculatorResults(null);
  };

  // 와이어 하위 탭 변경 핸들러
  const handleWireSubTabChange = (subTab) => {
    setActiveWireSubTab(subTab);
  };

  // 렌더링
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden p-4">
      <h2 className="text-xl font-bold mb-4">전기 기술 자료</h2>
      
      {/* 검색 */}
      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="검색어 입력"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      
      {/* 메인 탭 메뉴 */}
      <div className="flex mb-4 border-b">
        <button
          className={`py-2 px-4 ${activeTab === 'wire' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabChange('wire')}
        >
          전선 자료
        </button>
        <button
          className={`py-2 px-4 ${activeTab === 'calculator' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabChange('calculator')}
        >
          계산기
        </button>
        <button
          className={`py-2 px-4 ${activeTab === 'regulations' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
          onClick={() => handleTabChange('regulations')}
        >
          규격 및 법규
        </button>
      </div>
      
      {/* 전선 자료 탭 */}
      {activeTab === 'wire' && (
        <div>
          {/* 전선 자료 하위 탭 */}
          <div className="flex mb-4 bg-gray-100 rounded-lg p-1">
            <button
              className={`py-2 px-3 rounded ${activeWireSubTab === 'types' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:bg-gray-200'}`}
              onClick={() => handleWireSubTabChange('types')}
            >
              전선 종류별 사양
            </button>
            <button
              className={`py-2 px-3 rounded ${activeWireSubTab === 'current' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:bg-gray-200'}`}
              onClick={() => handleWireSubTabChange('current')}
            >
              전선 굵기별 허용전류
            </button>
            <button
              className={`py-2 px-3 rounded ${activeWireSubTab === 'application' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:bg-gray-200'}`}
              onClick={() => handleWireSubTabChange('application')}
            >
              용도별 권장 전선
            </button>
          </div>
          
          {/* 전선 종류별 사양 하위 탭 내용 */}
          {activeWireSubTab === 'types' && (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                {getFilteredData(wireTypesData).map((wire) => (
                  <div
                    key={wire.id}
                    className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow"
                    onClick={() => handleCardClick('wireType', wire)}
                  >
                    <h4 className="font-medium text-gray-800">{wire.title}</h4>
                    <p className="text-sm text-gray-600 mt-1">{wire.description}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* 전선 굵기별 허용전류 하위 탭 내용 */}
          {activeWireSubTab === 'current' && (
            <div>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full bg-white border">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="py-2 px-4 border">전선 굵기</th>
                      <th className="py-2 px-4 border">허용전류 (220V)</th>
                      <th className="py-2 px-4 border">허용전류 (380V)</th>
                      <th className="py-2 px-4 border">주요 용도</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredData(wireSizeCurrentData).map((item, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="py-2 px-4 border font-medium">{item.size}</td>
                        <td className="py-2 px-4 border">{item.allowableCurrent220V}</td>
                        <td className="py-2 px-4 border">{item.allowableCurrent380V}</td>
                        <td className="py-2 px-4 border">{item.application}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="bg-blue-50 p-3 rounded-md text-sm mb-4">
                <p className="font-medium text-blue-800 mb-1">참고사항:</p>
                <ul className="list-disc pl-5 text-gray-700">
                  <li>위 허용전류는 주위온도 30°C, 전선 3가닥 포설 기준</li>
                  <li>380V 데이터는 삼상 부하에 적용되며, 용량이 큰 산업용 장비에 주로 사용</li>
                  <li>실제 설계 시에는 보정계수(온도, 포설방법 등)를 적용해야 함</li>
                </ul>
              </div>
            </div>
          )}
          
          {/* 용도별 권장 전선 종류 하위 탭 내용 */}
          {activeWireSubTab === 'application' && (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {getFilteredData(wireApplicationData).map((item, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow"
                    onClick={() => handleCardClick('wireApplication', item)}
                  >
                    <h4 className="font-medium text-gray-800">{item.application}</h4>
                    <p className="text-sm text-gray-600 mt-1">{item.recommendedWire}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* 계산기 탭 */}
      {activeTab === 'calculator' && (
        <div>
          <h3 className="text-lg font-semibold mb-3">전선 굵기 계산기</h3>
          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 mb-2">부하 용량 (W)</label>
                <input
                  type="number"
                  name="load"
                  value={calculatorInputs.load}
                  onChange={handleCalculatorInputChange}
                  className="w-full p-2 border rounded"
                  placeholder="예: 2000"
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">배선 거리 (m)</label>
                <input
                  type="number"
                  name="distance"
                  value={calculatorInputs.distance}
                  onChange={handleCalculatorInputChange}
                  className="w-full p-2 border rounded"
                  placeholder="예: 15"
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">전압 종류</label>
                <select
                  name="voltageType"
                  value={calculatorInputs.voltageType}
                  onChange={handleCalculatorInputChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="220">단상 220V</option>
                  <option value="380">삼상 380V</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 mb-2">전선 종류</label>
                <select
                  name="wireType"
                  value={calculatorInputs.wireType}
                  onChange={handleCalculatorInputChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="CV">CV</option>
                  <option value="HIV">HIV</option>
                  <option value="VV">VV</option>
                </select>
              </div>
            </div>
            <button
              onClick={calculateWireSize}
              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
            >
              계산하기
            </button>
            
            {calculatorResults && (
              <div className="mt-4 p-4 bg-blue-50 rounded">
                <h4 className="font-medium text-blue-800 mb-2">계산 결과</h4>
                <p>계산된 전류: {calculatorResults.current}A</p>
                <p>전압강하: {calculatorResults.voltageDrop}V</p>
                <p>권장 전선 굵기: {calculatorResults.wireType} {calculatorResults.recommendedSize}</p>
              </div>
            )}
          </div>
          
          <h3 className="text-lg font-semibold mb-3">단위 변환 도구</h3>
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-medium text-gray-800 mb-2">전력 단위 변환</h4>
                <p className="text-sm text-gray-600">1kW = 1,000W</p>
                <p className="text-sm text-gray-600">1kVA = 1,000VA</p>
                <p className="text-sm text-gray-600">역률 0.8 기준: kVA = kW ÷ 0.8</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-800 mb-2">전선 단위 변환</h4>
                <p className="text-sm text-gray-600">AWG 14 ≈ 2.1mm²</p>
                <p className="text-sm text-gray-600">AWG 12 ≈ 3.3mm²</p>
                <p className="text-sm text-gray-600">AWG 10 ≈ 5.3mm²</p>
                <p className="text-sm text-gray-600">AWG 8 ≈ 8.4mm²</p>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* 규격 및 법규 탭 */}
      {activeTab === 'regulations' && (
        <div>
          <h3 className="text-lg font-semibold mb-3">전기 관련 규격 및 법규</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {getFilteredData(regulationsData).map((regulation) => (
              <div
                key={regulation.id}
                className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow"
                onClick={() => handleCardClick('regulation', regulation)}
              >
                <h4 className="font-medium text-gray-800">{regulation.title}</h4>
                <p className="text-sm text-gray-600 mt-1">{regulation.description}</p>
              </div>
            ))}
          </div>
          
          <div className="bg-blue-50 p-4 rounded-lg">
            <h4 className="font-medium text-blue-800 mb-2">내선규정 주요 내용</h4>
            <ul className="list-disc pl-10 text-sm text-gray-700">
              <li className="mb-1">분기회로 배선용량은 정격전류의 1.25배 이상으로 산정</li>
              <li className="mb-1">주택용 콘센트 회로는 2.5mm² 이상 사용</li>
              <li className="mb-1">조명 회로는 1.5mm² 이상 사용</li>
              <li className="mb-1">전열기구 전용 콘센트는 4.0mm² 이상 사용</li>
              <li className="mb-1">배선 보호용 과전류차단기는 전선 허용전류 이하로 설정</li>
            </ul>
          </div>
        </div>
      )}
      
      {/* 상세 정보 모달 */}
      {modalIsOpen && modalContent && (
        <div className="distribution-overlay" onClick={closeModal}>
          <div className="distribution-modal animate-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header gradient-header">
              <h2 className="modal-title text-white">
                {selectedCard.type === 'wireType' && modalContent.title}
                {selectedCard.type === 'wireApplication' && modalContent.application}
                {selectedCard.type === 'regulation' && modalContent.title}
              </h2>
              <button onClick={closeModal} className="distribution-close-button hover:bg-white/30">X</button>
            </div>
            <div className="modal-content-scroll">
              {selectedCard.type === 'wireType' && (
                <div className="p-2">
                  <p className="mb-4 text-gray-700">{modalContent.description}</p>
                  {/* 이미지 표시 조건부 렌더링 추가 */}
                  {false && (
                    <div className="mb-4">
                      <img src={modalContent.image} alt={modalContent.title} className="max-w-full rounded shadow-md" />
                    </div>
                  )}
                  <div className="bg-blue-50 p-3 rounded-md mb-4">
                    <h3 className="font-medium mb-2 text-blue-700">주요 특징:</h3>
                    {modalContent.id === 'cv' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>내열성, 내수성이 우수</li>
                        <li>옥외 배선, 지중 매설용으로 적합</li>
                        <li>전압: 450/750V</li>
                        <li>허용온도: 90°C</li>
                      </ul>
                    )}
                    {modalContent.id === 'hiv' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>내열성이 우수</li>
                        <li>옥내 배선용으로 적합</li>
                        <li>전압: 450/750V</li>
                        <li>허용온도: 75°C</li>
                      </ul>
                    )}
                    {modalContent.id === 'vv' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>일반적인 전력용 케이블</li>
                        <li>옥내외 배선용으로 사용</li>
                        <li>전압: 300/500V</li>
                        <li>허용온도: 70°C</li>
                      </ul>
                    )}
                    {modalContent.id === 'awg' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>미국 표준 전선 규격</li>
                        <li>숫자가 작을수록 전선 굵기가 굵음</li>
                        <li>AWG 14 = 약 2.1mm²</li>
                        <li>AWG 12 = 약 3.3mm²</li>
                        <li>AWG 10 = 약 5.3mm²</li>
                      </ul>
                    )}
                    {modalContent.id === 'hfix' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>내열성, 난연성이 우수한 전선</li>
                        <li>화재 시 유독가스 발생 최소화</li>
                        <li>소방설비 및 피난용 설비 배선에 사용</li>
                        <li>허용온도: 90°C</li>
                      </ul>
                    )}
                    {modalContent.id === 'xlpe' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>가교 폴리에틸렌 절연 구조</li>
                        <li>내열성, 내수성, 내화학성이 매우 우수</li>
                        <li>주로 고압/특고압 전력 케이블에 사용</li>
                        <li>허용온도: 90°C</li>
                      </ul>
                    )}
                    {modalContent.id === 'fr' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>난연성이 향상된 특수 케이블</li>
                        <li>화재 발생 시 불꽃 전파를 억제</li>
                        <li>다중 이용시설, 공공건물에 주로 사용</li>
                        <li>전압: 450/750V</li>
                      </ul>
                    )}
                    {modalContent.id === 'tfr-cv' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>화재 시에도 일정 시간 동안 기능 유지</li>
                        <li>내화성, 내열성, 난연성 모두 우수</li>
                        <li>소방설비, 비상전원 공급용으로 사용</li>
                        <li>화재 시 최소 30분 이상 기능 유지</li>
                      </ul>
                    )}
                    {modalContent.id === 'acb' && (
                      <ul className="list-disc pl-12 space-y-1">
                        <li>알루미늄 도체 사용으로 경량화</li>
                        <li>구리 전선보다 경제적이나 전기 저항이 높음</li>
                        <li>주로 대용량 송전선로에 사용</li>
                        <li>동등 용량 구리선 대비 약 50% 무게</li>
                      </ul>
                    )}
                  </div>
                  
                  <h3 className="font-medium mb-2 text-blue-700 border-b pb-1">상세 내용:</h3>
                  {modalContent.id === 'cv' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>CV 전선은 가교 폴리에틸렌 절연체와 비닐 외피로 구성된 전력 케이블로, 내구성과 절연성이 우수합니다. 주로 건물 인입선, 옥외 배선, 지중 매설용으로 사용됩니다. 습기와 자외선에 강하며 내구성이 높아 옥외 환경에 적합합니다.</p>
                      <p className="mt-2">굵기별로 6mm², 10mm², 16mm², 25mm² 등이 있으며, 수중 펌프 배선, 옥외 조명 등의 용도로 사용됩니다. 지중 매설 시에는 반드시 적절한 보호관을 사용해야 합니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'hiv' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>HIV 전선은 내열 비닐 절연전선으로, 옥내 배선에 주로 사용됩니다. 일반 전선보다 내열성이 우수해 75°C까지의 온도에서도 안정적으로 사용할 수 있습니다.</p>
                      <p className="mt-2">일반적으로 분전반 내부 배선, 콘센트 및 조명 회로 등 건물 내부 배선에 가장 많이 사용되는 전선입니다. 가는 단선과 굵은 연선 형태로 제공되며, 색상 코드를 통해 상(Phase), 중성선(Neutral), 접지(Ground) 등을 구분합니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'vv' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>VV 전선은 비닐 절연에 비닐 시스를 씌운 일반적인 전력 케이블입니다. CV 전선보다 내열성이 낮지만(70°C), 가격이 저렴하여 경제적인 옵션으로 사용됩니다.</p>
                      <p className="mt-2">주로 일반 건물의 저압 전력 인입선, 공장 내 기계 배선 등에 사용되며, 옥내외 모두 사용 가능하나 지중 매설 시에는 CV 케이블보다 내구성이 낮다는 점을 고려해야 합니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'awg' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>AWG(American Wire Gauge)는 미국에서 사용하는 전선 굵기 규격으로, 숫자가 작을수록 전선이 굵어집니다. 국내에서는 주로 mm² 단위를 사용하지만, 일부 수입 장비나 국제 표준에서는 AWG 규격이 사용됩니다.</p>
                      <p className="mt-2">일반적으로 AWG 14(≈2.1mm²)는 조명 회로, AWG 12(≈3.3mm²)는 일반 콘센트, AWG 10(≈5.3mm²)은 에어컨과 같은 대형 가전에 사용됩니다. 산업용으로는 AWG 8 이하의 더 굵은 전선이 사용됩니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'hfix' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>HFIX 전선은 내열 난연 비닐 절연전선으로, 화재 시 유독가스 발생이 적고 불꽃 전파를 억제하는 특성을 가지고 있습니다. 화재 안전이 중요한 장소에 적합합니다.</p>
                      <p className="mt-2">주로 소방 설비, 피난 유도등, 비상 조명 등의 배선에 사용되며, 화재 위험이 있는 공간이나 많은 사람이 모이는 다중이용시설에서 선호됩니다. 일반 HIV 전선보다 화재 안전성이 높지만 가격도 더 높습니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'xlpe' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>XLPE(가교 폴리에틸렌) 케이블은 고전압 전력 케이블에 주로 사용되는 우수한 절연체입니다. 일반 폴리에틸렌보다 내열성, 내화학성이 뛰어나며 전기적 특성도 우수합니다.</p>
                      <p className="mt-2">주로 6.6kV, 22.9kV 등의 고압 배전선로, 특고압 송전선로, 대형 변전소 연결선 등에 사용됩니다. 90°C까지의 고온에서도 안정적으로 사용할 수 있어 대용량 전력 전송에 적합합니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'fr' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>FR(Flame Retardant) 케이블은 난연성을 강화한 특수 케이블로, 화재 발생 시 불꽃의 전파를 억제하는 특성을 가지고 있습니다. 일반 케이블보다 화재 안전성이 높습니다.</p>
                      <p className="mt-2">주로 화재 위험이 높은 공간이나 대형 빌딩, 지하 구조물, 터널 등에 사용됩니다. 화재 발생 시 대피 시간을 확보하는 데 도움이 되며, 다중이용시설에서는 법적으로 요구되는 경우가 많습니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'tfr-cv' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>TFR-CV 케이블은 내화(Fire Resistant) 성능을 갖춘 특수 케이블로, 화재 발생 시에도 일정 시간(보통 30분~2시간) 동안 전기적 기능을 유지할 수 있습니다.</p>
                      <p className="mt-2">주로 소방 설비, 비상 발전기, 피난 유도등, 비상 엘리베이터 등 화재 시에도 작동이 필요한 중요 설비의 배선에 사용됩니다. 화재 발생 시 인명 구조와 소방 활동에 필수적인 설비의 전원을 안정적으로 공급하는 역할을 합니다.</p>
                    </div>
                  )}
                  {modalContent.id === 'acb' && (
                    <div className="bg-gray-50 p-3 rounded-md">
                      <p>ACB(Aluminum Conductor) 케이블은 구리 대신 알루미늄을 도체로 사용하는 전력 케이블입니다. 구리보다 가볍고 경제적이지만 전기 저항이 높아 동일 용량 전송 시 더 굵은 전선이 필요합니다.</p>
                      <p className="mt-2">주로 대용량 송전선로, 배전선로, 대형 건물의 인입선 등에 사용됩니다. 알루미늄의 열팽창률이 구리보다 높아 접속부 처리에 주의가 필요하며, 산화에 취약하므로 접속부에 특수 처리가 필요합니다.</p>
                    </div>
                  )}
                </div>
              )}
              
              {selectedCard.type === 'wireApplication' && (
                <div className="p-2">
                  <div className="bg-blue-50 p-3 rounded-md mb-4">
                    <h3 className="font-medium mb-2 text-blue-700">권장 전선:</h3>
                    <p className="mb-0 font-semibold">{modalContent.recommendedWire}</p>
                  </div>
                  <h3 className="font-medium mb-2 text-blue-700 border-b pb-1">설명:</h3>
                  <p className="mb-4">{modalContent.description}</p>
                  <h3 className="font-medium mt-4 mb-2 text-blue-700 border-b pb-1">설치 시 주의사항:</h3>
                  <ul className="list-disc pl-12 space-y-1 bg-gray-50 p-3 rounded-md">
                    <li>전선 굵기는 최소 기준이며, 부하 용량에 따라 증가 필요</li>
                    <li>배선 거리가 길 경우 전압강하를 고려하여 굵기 증가</li>
                    <li>접속부는 견고하게 시공하여 접촉 불량 방지</li>
                    <li>케이블 구부림 반경은 케이블 바깥지름의 6배 이상 유지</li>
                  </ul>
                  
                  <h3 className="font-medium mt-5 mb-2 text-blue-700 border-b pb-1">상세 내용:</h3>
                  <div className="bg-gray-50 p-3 rounded-md mt-2">
                    <p>{modalContent.details}</p>
                    
                    {modalContent.application === '일반 배선' && (
                      <p className="mt-2">일반 배선 회로는 15A 또는 20A 차단기로 보호되며, 한 회로당 연결되는 콘센트 수는 건축물의 용도와 면적에 따라 달라집니다. 과부하 방지를 위해 회로당 부하 용량을 제한하는 것이 중요합니다.</p>
                    )}
                    {modalContent.application === '에어컨 배선' && (
                      <p className="mt-2">에어컨은 기동 시 정격 전류의 최대 6~7배까지 전류가 상승할 수 있으므로, 적절한 용량의 차단기(20~30A)와 충분한 굵기의 전선을 사용해야 합니다. 또한 누전차단기 설치가 권장됩니다.</p>
                    )}
                    {modalContent.application === '주방 전용 배선' && (
                      <p className="mt-2">주방의 전기 기기는 동시에 여러 대가 사용될 수 있으므로, 별도의 전용 회로로 구성해야 합니다. 주방 전용 배선은 최소 20A 이상의 차단기로 보호되어야 하며, GFCI(누전차단) 콘센트 사용이 권장됩니다.</p>
                    )}
                    {modalContent.application === '전기레인지 배선' && (
                      <p className="mt-2">전기레인지는 대용량 전력 소비 기기로, 대부분 220V 단상 또는 380V 삼상 전원을 사용합니다. 인덕션과 같은 최신 제품은 순간 최대 전력이 매우 높으므로 충분한 여유를 두고 설계해야 합니다.</p>
                    )}
                    {modalContent.application === '욕실 전용 배선' && (
                      <p className="mt-2">욕실은 감전 위험이 높은 장소이므로 반드시 누전차단기(GFCI)를 설치해야 합니다. 모든 금속부는 접지해야 하며, 전기 설비는 물이 튀는 구역으로부터 최소 60cm 이상 떨어진 곳에 설치해야 합니다.</p>
                    )}
                    {modalContent.application === '옥외 배선' && (
                      <p className="mt-2">옥외 배선은 태양광, 강우, 온도 변화 등 기상 조건에 노출되므로 내후성이 중요합니다. 옥외용 방수 배선함, 방수 콘센트, 방수 스위치 등을 사용해야 하며, 피뢰 및 서지 보호 장치 설치도 고려해야 합니다.</p>
                    )}
                    {modalContent.application === '지중 매설 배선' && (
                      <p className="mt-2">지중 매설 시에는 외부 충격으로부터 케이블을 보호하기 위해 PVC 또는 PE 보호관을 사용해야 합니다. 매설 깊이는 보행자 구역에서 최소 60cm, 차량 통행 구역에서는 최소 90cm 이상이 권장됩니다. 케이블 위에는 경고 테이프를 설치하고, 매설 위치를 도면에 표시해야 합니다.</p>
                    )}
                    {modalContent.application === '소방 설비 배선' && (
                      <p className="mt-2">소방 설비 배선은 관련 법규(소방시설법 등)에 따라 내화 또는 내열 배선으로 시공해야 합니다. 소방 전원은 일반 전원과 별도로 분리되어야 하며, 화재 발생 시에도 정해진 시간(30분~2시간) 동안 기능을 유지해야 합니다. 또한 비상 전원과 연결되어 정전 시에도 작동이 가능해야 합니다.</p>
                    )}
                  </div>
                </div>
              )}
              
              {selectedCard.type === 'regulation' && (
                <div className="p-2">
                  {modalContent.id === 'tech-standard' && (
                    <>
                      <p className="mb-4 bg-blue-50 p-3 rounded-md">산업통상자원부에서 고시한 전기설비의 안전성 확보를 위한 기술적 요건을 규정한 것입니다.</p>
                      <h3 className="font-medium mt-4 mb-2 text-blue-700 border-b pb-1">주요 내용:</h3>
                      <ul className="list-disc pl-10 space-y-1">
                        <li>전기설비의 기술기준</li>
                        <li>발전소, 변전소 등의 전기공작물</li>
                        <li>전선로의 지지물, 전선 등</li>
                        <li>전기사용 장소의 배선 및 기계기구 등</li>
                        <li>전기철도의 전차선 등</li>
                      </ul>
                    </>
                  )}
                  {modalContent.id === 'wiring-reg' && (
                    <>
                      <p className="mb-4 bg-blue-50 p-3 rounded-md">한국전기공사협회에서 발행하는 국내 옥내 배선공사의 표준으로, 전기설비기술기준을 실무에 적용할 수 있도록 구체화한 것입니다.</p>
                      <h3 className="font-medium mt-4 mb-2 text-blue-700 border-b pb-1">주요 내용:</h3>
                      <ul className="list-disc pl-10 space-y-1">
                        <li>전선의 종류와 용도</li>
                        <li>배선방법에 따른 시설</li>
                        <li>옥내 배선의 분기회로</li>
                        <li>배선설비의 접지</li>
                        <li>과전류 보호장치와 개폐기</li>
                        <li>조명설비, 동력설비, 전열설비 등 시설방법</li>
                      </ul>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ElectricalReference; 